import Payment from 'assets/images/buySubscription/payment.svg'
import Shared from 'assets/images/buySubscription/shared.svg'
import SelectedPayment from 'assets/images/buySubscription/payment-selected.svg'
import SelectedShared from 'assets/images/buySubscription/shared-selected.svg'
export const InitPlans: IPlan[] = [
    {
        id: 2,
        text: 'اشتراکی',
        icon: Shared,
        selected: false,
        selectedIcon: SelectedShared,
        servicePackage: 1,
    },
    {
        id: 1,
        text: 'کارمزدی',
        icon: Payment,
        selected: false,
        selectedIcon: SelectedPayment,
        servicePackage: 3,
    },
    {
        id: 0,
        text: 'رایگان',
        icon: undefined,
        selected: false,
        selectedIcon: undefined,
        servicePackage: 2,
    },
]
